import { useEffect, useRef } from 'react'

export function usePrevious<T>(value: T): T | undefined {
  // Reading refs during render is part of the usePrevious feature
  // But it's not recommended otherwise
  // oxlint-disable-next-line react-compiler/react-compiler
  'use no memo'
  const ref = useRef<T>(null)
  useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current !== null ? ref.current : undefined
}
